module.exports = __webpack_public_path__ + "img/Cowboys-gc.e98c29fd.png";